import { useAppNudgeStore } from "@faire/retailer/features/Nudges/useAppNudgeStore";
import { getSettingEnableRetailerNotification } from "@faire/retailer/settings/getSettingEnableRetailerNotification";

import { useUpsellNudgeEligibility } from "./useUpsellNudgeEligibility";

export enum OwFNudges {
  NONE = "NONE",
  UPSELL_NUDGE_1 = "UPSELL_NUDGE_1",
  UPSELL_NUDGE_2 = "UPSELL_NUDGE_2",
}

export const useOwFNudgeEligibility = (pathname?: string) => {
  const [{ hasAcknowledgedOpenWithFaireNudge }, setAppNudgeStore] =
    useAppNudgeStore(["hasAcknowledgedOpenWithFaireNudge"]);
  const { isEligibleForUpsellNudge1, isEligibleForUpsellNudge2 } =
    useUpsellNudgeEligibility(pathname);

  let nudgeToShow: OwFNudges = OwFNudges.NONE;
  if (isEligibleForUpsellNudge2) {
    nudgeToShow = OwFNudges.UPSELL_NUDGE_2;
  } else if (isEligibleForUpsellNudge1) {
    nudgeToShow = OwFNudges.UPSELL_NUDGE_1;
  }

  const shouldShowOwFNudge =
    nudgeToShow !== OwFNudges.NONE && !getSettingEnableRetailerNotification();

  return {
    shouldShowOwFNudge,
    nudgeToShow,
    hasAcknowledgedOpenWithFaireNudge,
    setAppNudgeStore,
  };
};
